

/**
 * YoutubePlayer
 */
class YoutubePlayer {
    constructor(controller, element) {
        console.log('YoutubePlayer constructor [controller, element]', controller, element);

        element.youtubePlayer = () => this;

        this.controller = controller;
        this.element = element;
        this.youtubeId = element.dataset.ytid.split('|')[0];
        this.playlist = element.dataset.ytid.split('|')[1];
        this.YTPlayer = undefined;
			
        this.link = element.querySelector('a');
        this.link.addEventListener('click', this, false);

        this.init();
    }

    handleEvent(event) {
        console.log('YoutubePlayer.handleEvent(event) [event]', event);

        switch (event.type) {
            case 'click':
                this.load(event);
                break;
        }
    }

    init() {
        const thumbSrc = this.element.dataset.ytthumb || `https://img.youtube.com/vi/${this.youtubeId}/maxresdefault.jpg`;

        console.log('YoutubePlayer.init() [thumbSrc]', thumbSrc);

        this.element.style.backgroundImage = `url("${thumbSrc}")`;
    }

    load(event) {
        console.log('YoutubePlayer.load(event) [event]', event);

        event.preventDefault();

        var options = {
                width	: '100%',
                height	: '100%',
                // videoId	: this.youtubeId,
                playerVars	: {
                    'autoplay'	: 1,
                    'cc_load_policy'	: 1,
                    'vq'		: 'hd720',
                    'rel'		: 0,
                    'color'		: 'white',
                    'theme'		: 'light',
                    'showinfo'	: 1,
                    'autohide'	: 1,
                },
                events	: {
                    'onReady'		: this.onPlayerReady,
                    'onStateChange'	: this.onPlayerStateChange.bind(this),
                }
            };

        if (this.playlist) {
            options.videoId = this.youtubeId;
            options.playerVars.listType = 'playlist';
            options.playerVars.list = this.playlist;
        } else if (this.youtubeId.indexOf('PL') !== 0) {
            // Video Id
            options.videoId = this.youtubeId;
        } else {
            // Playlist Id
            options.playerVars.listType = 'playlist';
            options.playerVars.list = this.youtubeId;
        }

        // var localPlayer = this.YT.Player;
        this.YTPlayer = new YT.Player(this.link, options);
        // this.node.ytplayer = player;
        // console.log('player', player.a.id);
        // players[player.a.id] = player;
        console.log('YoutubePlayer.load() [this]', this);
    }

    pause() {
        console.log('YoutubePlayer.pause() [this]', this);

        if (this.YTPlayer) {
            this.YTPlayer.pauseVideo();
        }
    }

	onPlayerReady(event) {
        console.log('YoutubePlayer.onPlayerReady() [event]', event);
        
		// $(event.target.getIframe()).animate({'opacity':1}, 500, 'linear');
	}

	onPlayerStateChange(event) {
        console.log('YoutubePlayer.onPlayerStateChange() [event]', event);
		
		// console.log('event.target.a.id', event.target.a.id);
		if (event.data == YT.PlayerState.PLAYING) {
            // const playerId = event.target.a.id;

            if (this.controller && this.controller.stopPlayersExceptThis) {
                this.controller.stopPlayersExceptThis(this);
            }

			// console.log('this.node.style.backgroundImage', this.node.style.backgroundImage);
			this.element.style.background = 'none';
		}

		if (event.data == YT.PlayerState.ENDED) {
		}
		// console.log('players', players);
	}
}



export default YoutubePlayer;

